import axios from 'axios';

const DEV_SERVER =
    (process.env.NODE_ENV === 'development') ?
        'http://localhost:8080' :
        '';

const API_SERVER =
    (process.env.NODE_ENV === 'development') ?
        'http://www.ecbi.co.kr' :
        'http://www.ecbi.co.kr';

export async function authenticated() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/auth/loginCheck`
    );

    return response.data;
}

/**
 * 로그인 페이지
 * @param data {object} - {id, password}
 * @return {Promise<T>}
 */
export async function signIn(data) {
    const response = await axios.post(
        `${DEV_SERVER}/rest/auth/login`,
        data
    );

    return response.data;
}

/**
 * 로그아웃
 * @return {Promise<T>}
 */
export async function signOut() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/auth/logout`
    );

    return response.data;
}

/**
 * 회원가입 페이지
 * @param data
 * @return {Promise<T>}
 */
export async function signUp(data) {
    const response = await axios.post(
        `${DEV_SERVER}/rest/auth/signin`,
        data
    );

    return response.data;
}

/**
 * 회원가입 페이지 - 로그인 유효성 체크
 * @param id
 * @return {Promise<T>}
 */
export async function validateID({account_id: id}) {
    const response = await axios.get(
        `${DEV_SERVER}/rest/member/find/${id}`
    );

    return response.data;
}

/**
 * Dashboard 페이지
 * @return {Promise<T>}
 */
export async function getDashboard() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/dashboard`
    );

    return response.data;
}

const getParamsToString = (params) => {
    const paramList = [];

    for (const i in params) {
        if (Object.prototype.hasOwnProperty.call(params, i)) {
            if (params[i]) {
                paramList.push(`${i}=${params[i]}`);
            }
        }
    }

    return paramList.join('&');
};

/**
 * ECDI Dashboard
 * @param params
 * @return {Promise<T>}
 */
export async function getReportDashboard(params) {
    const {term = 'daily', ...rest} = params;
    const resultParam = getParamsToString({...rest});

    const response = await axios.get(
        `${DEV_SERVER}/rest/report/${term}?${resultParam}`
    );

    return response.data;
}

/**
 * ECDI 일간/주간/월간 비교
 * @param params
 * @return {Promise<T>}
 */
export async function getReportCompare(params) {
    const {term = 'daily', ...rest} = params;
    const resultParam = getParamsToString({...rest});

    const response = await axios.get(
        `${DEV_SERVER}/rest/report/${term}/compare?${resultParam}`
    );

    return response.data;
}

/**
 * ECDI 일간/주간/월간 경쟁 분석
 * @param params
 * @return {Promise<T>}
 */
export async function getReportCompetition(params) {
    const {term = 'daily', ...rest} = params;
    const resultParam = getParamsToString({...rest});

    const response = await axios.get(
        `${DEV_SERVER}/rest/report/${term}/competition?${resultParam}`
    );

    return response.data;
}

/**
 * ECDI 대카테고리 리스트
 * @return {Promise<T>}
 */
export async function getCategory() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category`
    );

    return response.data;
}

/**
 * ECDI 중카테고리 리스트
 * @return {Promise<T>}
 */
export async function getSubCategory(code) {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category/${code}`
    );

    return response.data;
}

/**
 * 권한 신청 대카테고리 리스트 전체 조회
 * @return {Promise<T>}
 */
export async function getAllCategory() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category/all`
    );

    return response.data;
}

/**
 * 권한 신청 중카테고리 리스트 전체 조회
 * @return {Promise<T>}
 */
export async function getAllSubCategory(code) {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category/${code}/all`
    );

    return response.data;
}

/**
 * 카테고리 권한 리스트 (카테고리 > 권한 신청 > 카테고리 권한 신청 현황)카테고리 권한 리스트 (카테고리 > 권한 신청 > 카테고리 권한 신청 현황)
 * @return {Promise<T>}
 */
export async function getMyCategoryAuthList() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category/auth/list/${getAccountId()}`
    );

    return response.data;
}

/**
 * 카테고리 권한 신청
 * @return {Promise<T>}
 */
export async function sendCategoryAuth(code) {
    // accountId
    // category2Id
    const response = await axios.post(
        `${DEV_SERVER}/rest/category/auth`,
        {
            accountId: getAccountId(),
            category2Id: code
        }
    );

    return response.data;
}

/**
 * 카테고리 권한 승인
 * @param category2Id
 * @return {Promise<T>}
 */
export async function approveCategoryAuth(accountId, code) {
    // accountId
    // category2Id
    const response = await axios.put(
        `${DEV_SERVER}/rest/category/auth`,
        {
            accountId,
            category2Id: code
        }
    );

    return response.data;
}

/**
 * 카테고리 권한 삭제
 * @param category2Id
 * @return {Promise<T>}
 */
export async function deleteCategoryAuth(accountId, code) {
    // accountId
    // category2Id
    const response = await axios.delete(
        `${DEV_SERVER}/rest/category/auth`,
        {
            data: {
                accountId,
                category2Id: code
            }
        }
    );

    return response.data;
}

/**
 * 카테고리 권한 전체 리스트
 * @return {Promise<T>}
 */
export async function getCategoryAuthList() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/category/auth/list`
    );

    return response.data;
}

/**
 * 사용자 정보 조회
 * @return {Promise<T>}
 */
export async function getProfile() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/member/find/${getAccountId()}`
    );

    return response.data;
}

/**
 * 사용자 정보 수정
 * Account > 프로필 변경
 * @param data
 * @return {Promise<T>}
 */
export async function updateProfile(data) {
    const response = await axios.put(
        `${DEV_SERVER}/rest/member/${getAccountId()}`,
        data
    );

    return response.data;
}

/**
 * 사용자 패스워드 수정
 * Account > Password 변경
 * @param data
 * @return {Promise<T>}
 */
export async function updateUserPassword(data) {
    // current_password,
    // new_password
    const response = await axios.put(
        `${DEV_SERVER}/rest/member/password/${getAccountId()}`,
        data
    );

    return response.data;
}

/**
 * Best 순위 리스트
 * @return {Promise<T>}
 */
export async function getBestRankList(platformCode, targetDate) {
    const response = await axios.get(
        `${API_SERVER}/api/${platformCode}/best?extractDt=${targetDate}`
    );

    return response.data;
}

/**
 * Best 순위 히스토리
 * @return {Promise<T>}
 */
export async function getBestRankHistory(
    platformCode, targetDate,
    dealCode, productNo
) {
    const response = await axios.post(
        `${API_SERVER}/api/best/prd-no/${productNo}`,
        {
            'end': `${targetDate} 23:59:59`,
            'site_cd': platformCode,
            'prd_no': productNo,
            'deal_cd': dealCode,
        }
    );

    const labels = [];
    const ranks = [];

    response.data.forEach(d => {
        labels.push(d.date_time);
        ranks.push(d.priority);
    })

    return {
        labels,
        ranks
    };
}

/**
 * Platform 리스트
 * @return {Promise<T>}
 */
export async function getPlatformList() {
    const response = await axios.get(
        `${API_SERVER}/api/best/platform`
    );

    return response.data;
}

/**
 * Site 리스트
 * Screenshot 페이지에서 사용
 * @return {Promise<T>}
 */
export async function getSiteList() {
    const response = await axios.get(
        `${DEV_SERVER}/rest/screenshot/site`
    );

    return response.data;
}

/**
 * Deal 리스트
 * Screenshot 페이지에서 사용
 * @return {Promise<T>}
 */
export async function getDealList(siteCode) {
    const response = await axios.get(
        `${DEV_SERVER}/rest/screenshot/deal?siteCode=${siteCode}`
    );

    return response.data;
}

/**
 * Screentshot 리스트
 * Screenshot 페이지에서 사용
 * @return {Promise<T>}
 */
export async function getScreenshotList(siteCode, dealCode, targetDate) {
    const response = await axios.get(
        `${DEV_SERVER}/rest/screenshot?siteCode=${siteCode}&dealCode=${dealCode}&targetDate=${targetDate}`
    );

    return response.data;
}

function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function getAccountId() {
    return getCookie('accountId');
}

export function getUserType() {
    return getCookie('userType');
}
